import { render } from "./HowToNavigateToACafe.vue?vue&type=template&id=48541f2b&scoped=true"
import script from "./HowToNavigateToACafe.vue?vue&type=script&lang=js"
export * from "./HowToNavigateToACafe.vue?vue&type=script&lang=js"

import "./HowToNavigateToACafe.vue?vue&type=style&index=0&id=48541f2b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48541f2b"]])

export default __exports__